import { IconFilePdf16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC, type SyntheticEvent } from 'react';

import { CardNarrowMenuItem } from '@/microfrontends/listing/shared/components/CardNarrowMenuItem';
import { useDownloadPDF } from '@/microfrontends/listing/shared/hooks/card/useDownloadPDF';

export const MenuItemDownloadPDFContainer: FC = () => {
  const downlaodPDF = useDownloadPDF();

  return (
    <CardNarrowMenuItem
      icon={<IconFilePdf16 />}
      title="Скачать PDF"
      onClick={(e: SyntheticEvent) => {
        e.stopPropagation();
        downlaodPDF();
      }}
    />
  );
};
